import { render, staticRenderFns } from "./UserProfileSettings.vue?vue&type=template&id=cc551fa2&scoped=true&"
import script from "./UserProfileSettings.vue?vue&type=script&lang=js&"
export * from "./UserProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSettings.vue?vue&type=style&index=0&id=cc551fa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc551fa2",
  null
  
)

export default component.exports